import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';
import { IRopeTypeSize } from 'src/models/rope-type.model';
import services from 'src/services/rope-type.service';

export const actionTypes = {
  ROPE_TYPE_FETCH: 'ROPE_TYPE_FETCH',
  ROPE_TYPE_ADD: 'ROPE_TYPE_ADD',
  ROPE_TYPE_UPDATE: 'ROPE_TYPE_UPDATE',
  ROPE_TYPE_DELETE: 'ROPE_TYPE_DELETE',
} as const;

// This is where we put the actions that have promise/async payload like HTTP request
export const asyncActions = {
  listGET: {
    type: actionTypes.ROPE_TYPE_FETCH,
    service: services.listGET,
  },
  addPOST: {
    type: actionTypes.ROPE_TYPE_ADD,
    service: services.addPOST,
    meta: { error: false },
  },
  updatePUT: {
    type: actionTypes.ROPE_TYPE_UPDATE,
    service: services.updatePUT,
    meta: { error: false },
  },
  itemDELETE: {
    type: actionTypes.ROPE_TYPE_DELETE,
    service: services.itemDELETE,
  },
};

export type IRopeTypeAsync = typeof asyncActions;

export interface IRopeTypeState extends ICommonState<IRopeTypeAsync> {
  data?: IRopeTypeSize;
  list: IRopeTypeSize[];
  total: number;
}

export const defaultState: IRopeTypeState = {
  status: {},
  list: [],
  total: 0,
};

const RopeTypeReducer = (
  state: IRopeTypeState = defaultState,
  action: IReducerAction<IRopeTypeAsync>
): IRopeTypeState => {
  switch (action.type) {
    case actionTypes.ROPE_TYPE_FETCH: {
      return {
        ...state,
        list: action.payload?.ropeType.rows ?? [],
        total: action.payload?.ropeType.count ?? 0,
      };
    }

    default: {
      return state;
    }
  }
};

export default RopeTypeReducer;
